import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@klear/ui/components/select'
import type { DocumentReviewRun } from '@klear/schema/document-review'
import type { NextStep } from '@klear/schema/document-review-step'
import { NEXT_STEP_LABELS } from '@/app/document-review/next-steps'
import { processingStatusLabel } from '@/app/document-review/review-labels'

type RunLike = Pick<DocumentReviewRun, 'run' | 'traderName' | 'status'>

function runLabel(run: RunLike, lead: string, state: string): string {
  return [lead, run.traderName ?? 'no trader', state].join(' · ')
}

export function runLine(run: RunLike): string {
  return runLabel(run, `Run ${run.run}`, processingStatusLabel(run.status))
}

export type RunSelectProps = {
  runs: readonly DocumentReviewRun[]
  currentId: string
  currentStep: NextStep
  onChange: (processingId: string) => void
}

export function RunSelect({ runs, currentId, currentStep, onChange }: RunSelectProps) {
  const ordered = [...runs].sort((a, b) => b.run - a.run)
  const current = ordered.find((run) => run.id === currentId)
  if (current === undefined) return null
  if (ordered.length === 1) {
    return (
      <span className="text-muted-foreground text-sm">
        {runLabel(current, `run ${current.run}`, NEXT_STEP_LABELS[currentStep].toLowerCase())}
      </span>
    )
  }
  return (
    <Select value={currentId} onValueChange={onChange}>
      <SelectTrigger
        aria-label="Which run of this document to show"
        className="text-muted-foreground hover:text-foreground h-7 w-auto gap-1.5 border-0 bg-transparent px-1.5 text-sm shadow-none focus:ring-0"
      >
        <SelectValue>
          {runLabel(current, `Run ${current.run} of ${ordered.length}`, NEXT_STEP_LABELS[currentStep].toLowerCase())}
        </SelectValue>
      </SelectTrigger>
      <SelectContent align="start">
        {ordered.map((run) => (
          <SelectItem key={run.id} value={run.id}>
            {runLine(run)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
